// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"159a24ad","453":"1769441b"}[chunkId] + ".chunk.js";
};